import React, { useEffect, useMemo, useState } from "react";
import { Navbar } from "../Components/custom/Navbar";
import { Box } from "@chakra-ui/react";
import { AllRoutes } from "../Routes/AllRoutes";
import { useSelector } from "react-redux";
import { SideMenu } from "../Components/custom/SideMenu";
import { useTheme } from "next-themes";

const SIDEBAR_COLLAPSED_KEY = "adminSidebarCollapsed";

export const Layout = () => {
  const { setTheme } = useTheme();
  useEffect(() => setTheme("light"), [setTheme]);

  const isAuthenticated = useSelector((state) => state?.Login?.isAuthenticated);
  const screenWidth = useSelector((state) => state?.CurrentScreenWidth?.width);

  // Breakpoints (match your current behavior)
  const isDesktop = screenWidth > 1024;
  const isTablet = screenWidth > 768 && screenWidth <= 1024;
  const isMobile = screenWidth <= 768;

  // Sidebar widths (px)
  const SIDE_MENU_OPEN_PX = 256;
  const SIDE_MENU_COLLAPSED_PX = 72;

  // State: remembered choice on desktop, collapsed by default on tablet
  const [isCollapsed, setCollapsedState] = useState(() => {
    try {
      const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
      if (saved !== null) return saved === "true";
    } catch (e) {}
    return isTablet;
  });
  const setCollapsed = (value) => {
    setCollapsedState(value);
    try {
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(value));
    } catch (e) {}
  };
  const [, setMobileOpen] = useState(false); // Drawer (mobile)

  // Actual sidebar width on current breakpoint
  const sidebarWidth = useMemo(() => {
    if (isDesktop || isTablet) return isCollapsed ? SIDE_MENU_COLLAPSED_PX : SIDE_MENU_OPEN_PX;
    return 0; // mobile uses Drawer overlay; main shouldn't shift
  }, [isDesktop, isTablet, isCollapsed]);

  const NAVBAR_HEIGHT = "64px";

  if (!isAuthenticated) {
    return (
      <Box width="100%" minH="100vh" display="flex" justifyContent="center" alignItems="center" bg="bg.canvas">
        <AllRoutes />
      </Box>
    );
  }

  return (
    <Box minH="100vh" bg="bg.canvas">
      {/* Fixed full-height sidebar for >=769px */}
      {!isMobile && (
        <Box
          as="aside"
          width={`${sidebarWidth}px`}
          position="fixed"
          top={0}
          left={0}
          bottom={0}
          zIndex={110}
          transition="width 240ms ease"
        >
          <SideMenu
            isCollapsed={isCollapsed}
            setCollapsed={setCollapsed}
            isMobileOpen={false}
            setMobileOpen={() => {}}
          />
        </Box>
      )}

      <Navbar setMobileOpen={setMobileOpen} leftOffset={sidebarWidth} />

      {/* Main content */}
      <Box
        as="main"
        marginLeft={`${sidebarWidth}px`}
        paddingTop={NAVBAR_HEIGHT}
        height="100vh"
        transition="margin-left 240ms ease"
      >
        <Box
          height={`calc(100vh - ${NAVBAR_HEIGHT})`}
          overflowY="auto"
          px={{ base: 4, md: 6, lg: 8 }}
          py={{ base: 4, md: 6 }}
        >
          <AllRoutes />
        </Box>
      </Box>
    </Box>
  );
};
